module Meevo.Components.Filters {
    export function meevoToArrayFilter() {
        const filter = (obj: any, addKey: boolean) => {
            if (!angular.isObject(obj)) return obj;
            if (addKey === false) {
                return Object.keys(obj).map(function (key) {
                    return obj[key];
                });
            } else {
                return Object.keys(obj).map(function (key) {
                    var value = obj[key];
                    return angular.isObject(value) ?
                        Object.defineProperty(value, '$key', { enumerable: false, value: key }) :
                        { $key: key, $value: value };
                });
            }
        }
        return filter; 
    }

    angular.module("meevo.components.filters")
        .filter("meevoToArray", meevoToArrayFilter);
}